<template>
    <div>
        <b-form-select v-model="localValue" :options="branches" :tabindex="tabindex"></b-form-select>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        value: null,
        tabindex: { type: [String, Number], default: 0 }
    },
    components: {},
    data() {
        return {
            localValue: null
        }
    },
    watch: {
        localValue(newValue) {
            this.$emit('input', newValue);
            this.$emit('change', newValue);
        },
        value(newValue) {
            this.localValue = newValue;
        },
    },
    computed: {
        ...mapGetters('my-company', {
            getCompanyFromStore: 'get'
        }),
        branches() {
            const company = this.getCompanyFromStore('mine');
            let branches = this.$copy(company.branches || []);
            branches.push({ ...company, _id: company.id });
            return branches.map(el => {
                return { value: el._id, text: el.name }
            })
        },
    },

    created() {
        this.localValue = this.value;
    },

    methods: {
        clear() {
            this.localValue = null;
        },
        updateValue() {
            this.$emit('input', this.localValue);
            this.$emit('change', this.localValue);
        }
    }

}
</script>
